var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWireframes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.245,
    height: 38.967,
    viewBox: "0 0 36.245 38.967",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specialist---View-directory-profile-v2-_collapsed_",
    "data-name": "Specialist---View-directory-profile-v2-(collapsed)",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eConsult"
  }, /*#__PURE__*/React.createElement("g", {
    id: "econsult-2",
    "data-name": "econsult"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M36.661,28.01a2.416,2.416,0,1,1,2.389-2.417A2.4,2.4,0,0,1,36.661,28.01Zm-9.543,0a2.416,2.416,0,1,1,2.389-2.417A2.4,2.4,0,0,1,27.118,28.01Zm-9.535,0a2.416,2.416,0,1,1,2.379-2.417A2.4,2.4,0,0,1,17.584,28.01ZM27.118,10C17.665,10,10,16.984,10,25.593c0,8.293,7.107,15.05,16.076,15.548.583,3.162,1.042,5.245,1.042,5.245a39.957,39.957,0,0,0,8.254-7.129,15.434,15.434,0,0,0,8.872-13.663C44.245,16.984,36.58,10,27.118,10Z",
    transform: "translate(-10 -10)",
    fill: "none",
    stroke: "#118847",
    strokeWidth: 2,
    fillRule: "evenodd"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWireframes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Wireframes.5698d0d39997f7f60aec2e65af5abf8b.svg";